module.exports = __webpack_public_path__ + "img/housebox-alt.e36ac0a3.svg";